export default {
  name: 'marking--orderCloseOrder',
  apiService: 'shoes',
  apiPath: '/admin/order/func/close_order',
  urlParamName: 'marking--orderCloseOrder',
};